import React, { useRef } from 'react';
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion';
import { images } from '../../data/images';
export function CampaignBanner() {
  const ref = useRef<HTMLDivElement>(null);
  const reduce = useReducedMotion();
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const scale = useTransform(scrollYProgress, [0, 0.5], reduce ? [1, 1] : [0.92, 1]);
  const radius = useTransform(scrollYProgress, [0, 0.5], reduce ? [32, 32] : [48, 24]);
  return <section aria-label="Nouveaux produits Aloesol" className="w-full bg-cream pb-24 md:pb-32" data-id="element-8" data-mp="w3ufhorx3et5">
      <div ref={ref} className="mx-auto max-w-[1600px] px-3 md:px-6" data-id="element-9" data-mp="r2n8vt1iglo2">
        <motion.div style={{
        scale,
        borderRadius: radius
      }} className="overflow-hidden bg-sage" data-id="element-10" data-mp="n3edkjqtofqe">
          <img src={images.campaignBanner} alt="Nouveaux produits Aloesol : crème réparatrice, gel 97% aloe vera et la plante d’aloe vera" className="h-auto w-full" data-id="element-11" data-mp="3bupaqxmtx80o" />
        </motion.div>
      </div>
    </section>;
}